import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Fab,
  DialogActions,
  Tabs,
  Tab,
  Autocomplete,
  InputAdornment
} from "@mui/material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS, ROLES } from "../../constants";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import CommonOtpModal from "./commonOtpModal";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import axios from "axios";
import { forEachChild } from "typescript";

import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
// import { addSchool } from 'path-to-your-database-file';



const isMobile = window.innerWidth < 900;

const TotalAmountTypography = styled(Typography)`
 
  position: absolute;
 
  bottom: 10px;
 
  right: 10px;
 
  font-size: ${isMobile ? "14px" : "inherit"};
 
  bottom: ${isMobile ? "85px" : "70px"};
 
  right: ${isMobile ? "15px" : "70px"};
 
`;
const ModalHeaderContainer = styled.div`
  display: flex ;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};

`;
const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0px;
  }
`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const StyledDialog = styled(Dialog)`
  position: relative;
`;

const FabStyle = styled(Fab)`
  && {
    z-index: 1;
  }
`;

const DataGridContainer = styled.div`
  width: 100%;
 
 
`;
const DataGridContainer1 = styled.div`
  width: 100%;
  margin-bottom:${!isMobile && "20px"};
 
//   height: 500px;
`;

const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;

const Input = styled.input`
  display: none;
`;


const SchoolModal = ({ props, onClose, onClose1, remarks, dataProp, id, distributorId, fetchData, status, }) => {
  // console.log("DATA prop", dataProp && dataProp[0]);
  const [changePassword, setChangePassword] = useState(false)
  const [tabValue, setTabValue] = useState(0);
  const { auth, setAuth } = useContext(AuthContext);
  // console.log("DATAAUTH", dataProp);

  const [details, setDetails] = useState(dataProp && dataProp[0]);
  const [employee, setEmployee] = useState([])
  const [fileUrl, setFileUrl] = useState();
  const [clusters, setClusters] = useState([]);
  const [schoolCategories, setSchoolCategories] = useState([]);

  const [roles, setRoles] = useState([])
  const [plantCode, setPlantCode] = useState("")
  const [loading, setLoading] = useState(false)
  const [product, setProduct] = useState()
  const [deletedField, setDeletedFields] = useState([])
  const [customerTypes, setCustomerTypes] = useState([]);
  const [schoolTypes, setSchoolTypes] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [remark, setRemrak] = useState(remarks)
  const [form, setForm] = useState({
    id: dataProp && dataProp[0]?.schoolId || "",
    "customer_type": "" || (dataProp && dataProp[0]?.customer_type),
    "school_type": "" || (dataProp && dataProp[0]?.school_type),
    "routeName": "" || (dataProp && dataProp[0]?.routeName),
    "partySource": "" || (dataProp && dataProp[0]?.partySource),
    "schoolName": "" || dataProp && dataProp[0]?.schoolName,
    "parentSchoolName": "" || dataProp && dataProp[0]?.parentSchoolName,
    "board": "" || dataProp && dataProp[0]?.board,
    "medium": "" || dataProp && dataProp[0]?.medium,
    // "incorporationDate": "" || dataProp && dataProp[0]?.incorporationDate,
    "email": "" || dataProp && dataProp[0]?.email,
    "website": "" || dataProp && dataProp[0]?.website,
    // "gstNo": "" || dataProp && dataProp[0]?.gstNo,
    "grade": "" || dataProp && dataProp[0]?.grade,
    "strength": "" || dataProp && dataProp[0]?.strength,
    "onboardforErp": "" || dataProp && dataProp[0]?.onboardForErp,
    "pincode": "" || dataProp && dataProp[0]?.Pincode,
    "state": "" || dataProp && dataProp[0]?.State,
    "district": "" || dataProp && dataProp[0]?.District,
    "addressLine1": "" || dataProp && dataProp[0]?.AddressLine1,
    "addressLine2": "" || dataProp && dataProp[0]?.AddressLine2,
    "cluster":"" || dataProp && dataProp[0]?.cluster,
    "landmark": "" || dataProp && dataProp[0]?.Landmark,
    "location": "" || dataProp && dataProp[0]?.Location,
    "makerName": "" || dataProp && dataProp[0]?.makerName,
    "makerContact": "" || dataProp && dataProp[0]?.makerContact,
    "ownerId": "" || dataProp && dataProp[0]?.ownerId,
    "distributorId": "" || dataProp && dataProp[0]?.distributorID,
    "makerRole": "" || dataProp && dataProp[0]?.makerRole,
    // "affiliationPan": "" || dataProp && dataProp[0]?.affiliation_or_pan,
    // "registrationNo": "" || dataProp && dataProp[0]?.registratioNo,
    // "bankName": "" || dataProp && dataProp[0]?.bankName,
    // "holderName": "" || dataProp && dataProp[0]?.accountHolderName,
    // "branchName": "" || dataProp && dataProp[0]?.branchName,
    // "accountNo": "" || dataProp && dataProp[0]?.accountNo,
    // "ifsc": "" || dataProp && dataProp[0]?.ifscCode,
    "makerRole": "" || dataProp && dataProp[0]?.decisionMakerRole,
    // "chequePic": "" || dataProp && dataProp[0]?.chequePic,
    // "schoolPic": "" || dataProp && dataProp[0]?.schoolPic,
    // "panPic": "" || dataProp && dataProp[0]?.panPic,
    // "contactPersonPic": "" || dataProp && dataProp[0]?.contactPersonPic,
    "schoolCategory": "" || dataProp && dataProp[0]?.schoolCategory,
    "startTime": "" || dataProp && dataProp[0]?.start_time,
    "endTime": "" || dataProp && dataProp[0]?.end_time
  })

  const [isCancelChequeUploaded, setIsCancelChequeUploaded] = useState(false);
  const [isSchoolPhotoUploaded, setIsSchoolPhotoUploaded] = useState(false);
  const [isPanCardUploaded, setIsPanCardUploaded] = useState(false);
  const [isContactPersonUploaded, setIsContactPersonUploaded] = useState(false);

  const [errors, setErrors] = useState({});
  const [date, setDate] = useState()
  const [assignedEmp, setAssignedEmp] = useState(null)
  const [distributor, setDistributor] = useState([])
  const [selectDistributor, setSelectDistributor] = useState(null)
  const [board, setBoard] = useState()
  const [partySources, setPartySources] = useState([]);
  const [medium, setMedium] = useState()
  const [lead, setLead] = useState([])
  const [selectedLead, setSelectedLead] = useState(null)
  const [contactPersonRole, setContactPersonRole] = useState([])
  const [grade, setGrade] = useState([])
  const [selectedGrade, setSelectedGrade] = useState([])

  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState(dataProp && dataProp[0]?.schoolCategory || '');

  // console.log(dataProp && dataProp," dataProp && dataprop")
  const handleChange = (event) => {
    setSelectedCategory(event.target.value);
    changeHandler("schoolCategory", event.target.value);
  };

  const handleClear = () => {
    setSelectedCategory('');
    changeHandler("schoolCategory", '');
  };



  const getCustomerType = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getCustomerTypeList();
      if (results?.status) {
        setCustomerTypes(results?.data || []);
        setLoading(false);
      }
      else {
        setLoading(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
    } catch (error) {
      setLoading(false);
      window.NotificationUtils.showError("Error fetching input sources");
    }
  };

   const getClusterInPicklist = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getClusterInPicklist();
      const jsonArrayWithId = results?.data?.map((obj) => ({
        ...obj,
        dbId: obj.id
      }));
      setClusters(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  };

  const getSchoolType = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getSchoolTypeList();
      if (results?.status) {
        setSchoolTypes(results?.data || []);
        setLoading(false);
      }
      else {
        setLoading(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
    } catch (error) {
      setLoading(false);
      window.NotificationUtils.showError("Error fetching input sources");
    }
  };

  const handleChangeTab = (event, newValue) => {
    // console.log("newValue: ", newValue);
    setTabValue(newValue);
  };

  // const storeSelectedGrades = (value) => {
  //   setSelectedGrade(value);
  // }

  // const storeSelectedGrades = (value) => {
  //   console.log(value, "storeSelectedGrades")
  //   // Extract only gradeId from the selected grades and set it
  //   const gradeIds = value?.map((grade) => grade?.gradeId);
  //   setSelectedGrade(gradeIds);  // Now, selectedGrade will be an array of gradeIds only
  // };

  const storeSelectedGrades = (value) => {
  const gradeIds = value?.map((grade) => grade?.gradeId);
  setSelectedGrade(gradeIds);
  setForm((prevForm) => ({ ...prevForm, grade: gradeIds }));
};

  // yaha tak 

  // const handleStartTimeChange = (newValue) => {
  //   setStartTime(newValue);
  //   const formattedTime = dayjs(newValue).format("HH:mm:ss");
  //   setForm((prevForm) => ({ ...prevForm, 'startTime': formattedTime }));
  //   if (endTime && newValue && dayjs(endTime).isBefore(newValue)) {
  //     setEndTime(null);
  //   }
  // };

  // const handleEndTimeChange = (newValue) => {
  //   setEndTime(newValue);
  //   const formattedTime = dayjs(newValue).format("HH:mm:ss");
  //   setForm((prevForm) => ({ ...prevForm, 'endTime': formattedTime }));
  // };
  const handleStartTimeChange = (newValue) => {
    setStartTime(newValue);
    // Format the start time in 24-hour format
    const formattedTime = dayjs(newValue).format("HH:mm:ss");
    setForm((prevForm) => ({ ...prevForm, startTime: formattedTime }));

    // If the end time is before the new start time, reset it
    if (endTime && newValue && dayjs(endTime).isBefore(newValue)) {
      setEndTime(null);
    }
  };
  console.log(form)
  const handleEndTimeChange = (newValue) => {
    setEndTime(newValue);
    // Format the end time in 24-hour format
    const formattedTime = dayjs(newValue).format("HH:mm:ss");
    setForm((prevForm) => ({ ...prevForm, endTime: formattedTime }));
  };

  const getSchoolCategories = async () => {
    try {

      setLoading(true);
      let results = await window.Platform.database.getSchoolCategories();
      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
      else {
        setSchoolCategories(results?.data);
        setLoading(false)
      }

      // const jsonArrayWithId = results?.data?.map((obj, index) => ({
      //   ...obj,
      //   id: index + 1,
      // }));

      // setAccessChanges(jsonArrayWithId);
      setLoading(false);

    } catch (error) {
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchEmployees()
    fetchDistributors()
    getBoard()
    getPartySource()
    getMedium()
    getContactPersonRole()
    getGrade()
    getCustomerType();
    getClusterInPicklist();
    getSchoolType();
    getSchoolCategories();
    // Prefill grade selection based on grade ids from payload
    if (dataProp && dataProp[0]) {
      const createdAt = dayjs(dataProp && dataProp[0]?.createdAt);
      if (dataProp && dataProp[0]?.start_time) {
        exctractingTimePickers('startTime', createdAt, dataProp && dataProp[0]?.start_time);
      }

      if (dataProp && dataProp[0]?.end_time) {
        exctractingTimePickers('endTime', createdAt, dataProp && dataProp[0]?.end_time);
      }

      // Prefill grade selection
      let gradeIds = [];
      if (dataProp[0]?.grade) {
        if (Array.isArray(dataProp[0].grade)) {
          gradeIds = dataProp[0].grade;
        } else if (typeof dataProp[0].grade === 'string') {
          gradeIds = dataProp[0].grade.split(',');
        }
      }
      setSelectedGrade(gradeIds);
      setForm((prevForm) => ({ ...prevForm, grade: gradeIds }));
    }
  }, [])

  // useEffect(() => {
  // if(tabValue===1){
  //   fetchProduct(plantCode,distributorId)
  // }

  // console.log("first", dataProp && dataProp[0])

  //   if (!status) {
  //     const newDate = new Date(dataProp && dataProp[0].incorporationDate)
  //     formatDate(dayjs(newDate))
  //     const resultArray = dataProp && dataProp[0]?.grade?.split(',');
  //     setSelectedGrade(resultArray)
  //     // console.log(resultArray);

  //   }
  //   // console.log("currentTab", tabValue)
  // }, [])

  const exctractingTimePickers = (fieldName, createdAt, time) => {
    const [hours, minutes, seconds] = time?.split(':');

    const parsedTime = createdAt
      .hour(parseInt(hours, 10))
      .minute(parseInt(minutes, 10))
      .second(parseInt(seconds, 10));

    if (fieldName === "startTime") {
      setStartTime(parsedTime);
    } else {
      setEndTime(parsedTime);
    }

    changeHandler(fieldName, parsedTime);
  }

  const changeHandler = (fieldName, value) => {

    if (fieldName === 'accountNo') {
      const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 17);
      setForm((prevErrors) => ({
        ...prevErrors,
        accountNo: sanitizedValue,
      }));
      return;
    }

    if (fieldName === "makerContact" || fieldName === "strength") {
      const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
      setForm((prevForm) => ({ ...prevForm, [fieldName]: sanitizedValue }))
    }
    else {
      setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
    }
  };

  const schoolBoard = [{ id: 1, value: "CBSE" }, { id: 2, value: "ICSE" }, { id: 3, value: "State Board" }]
  const schoolMedium = [{ id: 1, value: "Hindi" }, { id: 2, value: "English" }]

  const renderContent1 = () => {
    return (
      <div style={{  }}>
        <Stack direction={"row"} spacing={2} padding={2}>
          <Autocomplete
            options={employee}
            disabled={loading}

            // getOptionLabel={}
            // multiple
            // getOptionLabel={(option) => `${option?.name} (${option?.id})`}
            // getOptionLabel={(option) => `${option?.name}`}
              getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
            getOptionValue={(option) => option?.id || ''}
            style={{ width: "100%" }}
            value={assignedEmp}
            // disabled={loading 
            // || !addNewMode || props.isManager
            // }
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              // console.log("TEST1212", value)
              changeHandler("ownerId", value?.id)
              setAssignedEmp(value);
              getLeadParty(value?.id)

              //  updateDataGrid(value);

              // if(selectedCity.warehouseCountry === 'India' && warehouseData.attributes.warehouseCountry === 'China')
              // {
              //     setDisableTransfer(false)
              // }
              // else
              // setDisableTransfer(true)



            }}
            onInputChange={(e, value) => {
              // Check if the user's input matches any option
              // const matchingOption = employee.find((option) => option.name === value.name);

              // if (!matchingOption ) {
              //   // If there's no matching option, set the otherValue to null
              // //   setDeliveryCity(null);
              // setAssignedEmp();
              // return;
              // }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                // disabled={
                //   loading 
                // || !addNewMode || props.isManager || props.isDeleted
                // }

                label={"Assign To"}
                size="small"
                required
                variant="outlined"
                error={errors.assignTo ? true : false}
                InputProps={{
                  ...params.InputProps,
                  style: { ...params.InputProps?.style, color: "black", fontWeight: "500", fontSize: "14px" }, // input text color
                }}
                InputLabelProps={{
                  ...params.InputLabelProps,
                  style: { color: "black", fontWeight: "500", fontSize: "15px" }, // label color
                }}
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: '#222', // dark placeholder
                    opacity: 1,
                  },
                }}
              />
            )} />
          {/* BAsss */}

          {/* {!(dataProp && dataProp[0]?.schoolId) && <TextField label="School Name" value={form?.schoolName || ""} type="text" fullWidth onChange={(e) => changeHandler("schoolName", e.target.value)} required error={errors.schoolName ? true : false} />
          } */}
          <TextField label="School Name" value={form?.schoolName || ""} type="text" fullWidth size="small" onChange={(e) => changeHandler("schoolName", e.target.value)} required error={errors.schoolName ? true : false}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          {dataProp && dataProp[0]?.schoolId && (
            <TextField disabled label="Party Id" size="small" value={dataProp && dataProp[0]?.schoolId || ""} type="text"
              sx={{
                width: "350px",
                '& .MuiInputLabel-root': {
                  color: 'black',
                  fontWeight: 500,
                },
                '& .MuiInputBase-input.Mui-disabled': {
                  color: '#111 !important',
                  fontWeight: 500,
                  WebkitTextFillColor: '#111',
                  opacity: 1,
                },
              }}
              InputProps={{
                style: {
                  color: '#111',
                  fontWeight: 500,
                  WebkitTextFillColor: '#111',
                  opacity: 1,
                  background: 'transparent',
                }
              }}
            />
          )}

        </Stack>
        {/* {dataProp && dataProp[0]?.schoolId && <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="School Name" value={form?.schoolName || ""} type="text" fullWidth onChange={(e) => changeHandler("schoolName", e.target.value)} required error={errors.schoolName ? true : false} />

        </Stack>} */}
        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl fullWidth size="small" variant="outlined" disabled={loading}>
            <InputLabel id="school-category-label" sx={{ color: 'black', fontWeight: "500", fontSize: "15px" }}>School Category</InputLabel>
            <Select
              labelId="school-category-label"
              label="School Category"
              value={form?.schoolCategory  || ""}
              sx={{ color: "black", fontWeight: "500" }}
              // onChange={handleChange}
              onChange={(event)=>changeHandler("schoolCategory", event.target.value)}
              endAdornment={
                selectedCategory && (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClear} size="small">
                      <ClearIcon sx={{ color: "black", fontWeight: "500" }} />
                    </IconButton>
                  </InputAdornment>
                )
              }
            >
              {loading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} />
                </MenuItem>
              ) : (
                schoolCategories?.map((option) => (
                  <MenuItem key={option?.id} value={option?.id} sx={{ color: "black", fontWeight: "500" }}>
                    {option?.name}
                  </MenuItem>
                ))
              )}
              {!loading && schoolCategories?.length === 0 && (
                <MenuItem disabled sx={{ color: "black", fontWeight: "500" }}>No options</MenuItem>
              )}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small" variant="outlined" disabled={loading}>
            <InputLabel id="input-source-label" sx={{ color: 'black', fontWeight: "500", fontSize: "15px" }}>Select School Type</InputLabel>
            <Select
              labelId="input-source-label"
              label="Select School Type"
              sx={{ color: "black", fontWeight: "500" }}
              value={form?.school_type || ""}
              onChange={(e) => changeHandler("school_type", e.target.value)}
            >
              {schoolTypes?.map((option) => (
                <MenuItem key={option.id} value={option.id} sx={{ color: "black", fontWeight: "500" }}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small" variant="outlined">
            <InputLabel id="input-source-label" sx={{ color: 'black', fontWeight: "500", fontSize: "15px" }}>Party Source</InputLabel>
            <Select
              labelId={`PartySource`}
              label="Party Source"
              sx={{ color: "black", fontWeight: "500" }}
              value={form?.partySource || ""}
              onChange={(e) => changeHandler("partySource", e.target.value)}
            >
              {partySources?.map((option, optionIndex) => (
                <MenuItem key={option?.optionIndex} value={option?.id} sx={{ color: "black", fontWeight: "500" }}>
                  {option?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="Parent School Name" value={form?.parentSchoolName || ""} type="text"  fullWidth size="small"  onChange={(e) => changeHandler("parentSchoolName", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          <TextField label="Email"
            value={form?.email || ""}
            type="email"
             fullWidth size="small" 
            onChange={(e) => changeHandler("email", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          <TextField label="Route Name" value={form?.routeName || ""} type="text"  fullWidth size="small"  onChange={(e) => changeHandler("routeName", e.target.value)} required error={errors.routeName ? true : false}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
        </Stack>
        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="Route Name" value={form?.routeName || ""} type="text" fullWidth onChange={(e) => changeHandler("routeName", e.target.value)} required
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          <FormControl variant="outlined" style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="input-source-label" sx={{ color: 'black', fontWeight: "500", fontSize: "15px" }}>Party Source</InputLabel>
            <Select
              labelId={`PartySource`}
              label="Party Source"
              sx={{ color: "black", fontWeight: "500" }}
              value={form?.partySource || ""}
              onChange={(e) => changeHandler("partySource", e.target.value)}
            >
              {partySources?.map((option, optionIndex) => (
                <MenuItem key={option?.optionIndex} value={option?.id} sx={{ color: "black", fontWeight: "500" }}>
                  {option?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack> */}
        <Stack direction={"row"} spacing={2} padding={2}>
          {/* <TextField label="Website" value={form?.website || ""} type="text" fullWidth onChange={(e) => changeHandler("website", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          /> */}
          <TextField
            label="Decision Maker Name"
            value={form?.makerName || ""}
            type="text"
             fullWidth size="small" 
            onChange={(e) => changeHandler("makerName", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          <TextField label="Decision Maker Mobile No"
            value={form?.makerContact || ""}
            type="text"
             fullWidth size="small" 
            onChange={(e) => changeHandler("makerContact", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
            error={errors.makerContact ? true : false}
          />
          <FormControl  fullWidth size="small" 
            variant="outlined">
            <InputLabel sx={{ color: "black", fontWeight: "500" }} >Decision Maker Role</InputLabel>
            <Select
              labelId={`Product`}
              label="Decision Maker Role"
              sx={{ color: "black", fontWeight: "500" }}
              value={form?.makerRole || ""}
              onChange={(e) => changeHandler("makerRole", e.target.value)}
            >
              {contactPersonRole?.map((option, optionIndex) => (
                <MenuItem key={option?.contactPersonRoleId} value={option?.contactPersonRoleId} sx={{ color: "black", fontWeight: "500" }}>
                  {option?.roleName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="Decision Maker Mobile No"
            value={form?.makerContact || ""}
            type="text"
            fullWidth
            onChange={(e) => changeHandler("makerContact", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
            error={errors.makerContact ? true : false}
          />
          <FormControl
            variant="outlined" style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel sx={{ color: "black", fontWeight: "500" }} >Decision Maker Role</InputLabel>
            <Select
              labelId={`Product`}
              label="Decision Maker Role"
              sx={{ color: "black", fontWeight: "500" }}
              value={form?.makerRole || ""}
              onChange={(e) => changeHandler("makerRole", e.target.value)}
            >
              {contactPersonRole?.map((option, optionIndex) => (
                <MenuItem key={option?.contactPersonRoleId} value={option?.roleName} sx={{ color: "black", fontWeight: "500" }}>
                  {option?.roleName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack> */}
        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl  fullWidth size="small"  variant="outlined">
            <InputLabel sx={{ color: "black", fontWeight: "500" }} >School Board</InputLabel>
            <Select
              labelId={`Product`}
              label="School Board"
              fullWidth
              value={form?.board || ""}
              sx={{ color: "black", fontWeight: "500" }}
              onChange={(e) => changeHandler("board", e.target.value)}
            // required
            // error={errors.board ? true : false}
            >
              {board?.map((option, optionIndex) => (
                <MenuItem key={option?.boardId} value={option?.boardId} sx={{ color: "black", fontWeight: "500" }}>
                  {option?.boardName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant="outlined"  fullWidth size="small" >
            <InputLabel id={`select-label`} sx={{ color: "black", fontWeight: "500" }}>School Medium</InputLabel>
            <Select
              labelId={`Product`}
              label="School Medium"
              value={form?.medium}
              fullWidth
              sx={{ color: "black", fontWeight: "500" }}
              onChange={(e) => changeHandler("medium", e.target.value)}
            // required
            // error={errors.medium ? true : false}
            >
              {medium?.map((option, optionIndex) => (
                <MenuItem key={option?.mediumTableId} value={option?.mediumTableId} sx={{ color: "black", fontWeight: "500" }}>
                  {option?.mediumName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl  fullWidth size="small" >
            <TextField label="Website" value={form?.website || ""} type="text"  fullWidth size="small"  onChange={(e) => changeHandler("website", e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: 'black',
                  fontWeight: 500,
                }
              }}
              InputProps={{
                style: {
                  color: '#111',
                  fontWeight: 500,
                  WebkitTextFillColor: '#111',
                  opacity: 1,
                  background: 'transparent',
                }
              }}
            />
          </FormControl>
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl  fullWidth size="small"  variant="outlined" disabled={loading}>
            <InputLabel id="input-source-label" sx={{ color: "black", fontWeight: "500" }}>Select Customer Type</InputLabel>
            <Select
              labelId="input-source-label"
              label="Select Customer Type"
              value={form?.customer_type || ""}
              sx={{ color: "black", fontWeight: "500" }}
              onChange={(e) => changeHandler("customer_type", e.target.value)}
            >
              {customerTypes?.map((option) => (
                <MenuItem key={option.id} value={option.id} sx={{ color: "black", fontWeight: "500" }}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* <TextField label="Strength" 146302
            value={form?.strength || ""}
            type="text"
            fullWidth
            onChange={(e) => changeHandler("strength", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          /> */}
          <FormControl variant="outlined" required style={{ width: isMobile ? "100%" : "100%" }}>
            <Autocomplete
             fullWidth size="small" 
              multiple
              options={grade}
              getOptionLabel={(option) => option?.gradeName} // Display gradeName
              getOptionSelected={(option, value) => option?.gradeId === value?.gradeId} // Ensure proper selection matching
              value={grade?.filter((g) => selectedGrade?.includes(g?.gradeId))} // Filter the grades that are selected
              onChange={(event, newValue) => {
                storeSelectedGrades(newValue); // Only store gradeId(s)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grade"
                   fullWidth size="small" 
                  variant="outlined"
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: '#111',
                      fontWeight: 500,
                    },
                    '& .MuiInputBase-input': {
                      color: '#111',
                      fontWeight: 500,
                    },
                  }}
                  InputProps={{
                    ...params.InputProps,
                    style: { color: '#111', fontWeight: 500 },
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    style: { color: '#111', fontWeight: 500 },
                  }}
                />
              )}
              noOptionsText={loading ? 'Loading...' : 'No options'}
              InputProps={{
                style: { color: "black", fontWeight: "500", fontSize: "14px" }, // input text color
              }}
              InputLabelProps={{
                style: { color: "black", fontWeight: "500", fontSize: "15px" }, // label color
              }}
              sx={{
                '& .MuiInputBase-input::placeholder': {
                  color: '#222', // dark placeholder
                  opacity: 1,
                },
              }}
            />
          </FormControl>
          <Autocomplete
            disabled={loading}
            options={distributor}
             fullWidth size="small" 
            getOptionLabel={(option) => `${option?.DistributorName}`}
            getOptionValue={(option) => option?.distributorID || ''}
            style={{ width: "100%" }}
            value={selectDistributor}
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              changeHandler("distributorId", value?.distributorID)
              setSelectDistributor(value)
            }}
            onInputChange={(e, value) => {

            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Assign Distributor"}
                 fullWidth size="small" 
                variant="outlined"
                sx={{
                  '& .MuiInputLabel-root': {
                    color: '#111',
                    fontWeight: 500,
                  },
                  '& .MuiInputBase-input': {
                    color: '#111',
                    fontWeight: 500,
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  style: { color: '#111', fontWeight: 500 },
                }}
                InputLabelProps={{
                  ...params.InputLabelProps,
                  style: { color: '#111', fontWeight: 500 },
                }}
              />
            )} />

        </Stack>
        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl variant="outlined" required style={{ width: isMobile ? "100%" : "100%" }}>
            <Autocomplete
              multiple
              options={grade}
              getOptionLabel={(option) => option?.gradeName} // Display gradeName
              getOptionSelected={(option, value) => option?.gradeId === value?.gradeId} // Ensure proper selection matching
              value={grade?.filter((g) => selectedGrade?.includes(g?.gradeId))} // Filter the grades that are selected
              onChange={(event, newValue) => {
                storeSelectedGrades(newValue); // Only store gradeId(s)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grade"
                  variant="outlined"
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: '#111',
                      fontWeight: 500,
                    },
                    '& .MuiInputBase-input': {
                      color: '#111',
                      fontWeight: 500,
                    },
                  }}
                  InputProps={{
                    ...params.InputProps,
                    style: { color: '#111', fontWeight: 500 },
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    style: { color: '#111', fontWeight: 500 },
                  }}
                />
              )}
              noOptionsText={loading ? 'Loading...' : 'No options'}
              InputProps={{
                style: { color: "black", fontWeight: "500", fontSize: "14px" }, // input text color
              }}
              InputLabelProps={{
                style: { color: "black", fontWeight: "500", fontSize: "15px" }, // label color
              }}
              sx={{
                '& .MuiInputBase-input::placeholder': {
                  color: '#222', // dark placeholder
                  opacity: 1,
                },
              }}
            />
          </FormControl>
          <Autocomplete
            disabled={loading}
            options={distributor}
            getOptionLabel={(option) => `${option?.DistributorName}`}
            getOptionValue={(option) => option?.distributorID || ''}
            style={{ width: "100%" }}
            value={selectDistributor}
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              changeHandler("distributorId", value?.distributorID)
              setSelectDistributor(value)
            }}
            onInputChange={(e, value) => {

            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Assign Distributor"}
                variant="outlined"
                sx={{
                  '& .MuiInputLabel-root': {
                    color: '#111',
                    fontWeight: 500,
                  },
                  '& .MuiInputBase-input': {
                    color: '#111',
                    fontWeight: 500,
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  style: { color: '#111', fontWeight: 500 },
                }}
                InputLabelProps={{
                  ...params.InputLabelProps,
                  style: { color: '#111', fontWeight: 500 },
                }}
              />
            )} />
        </Stack> */}
        <Stack direction={"row"} spacing={2} padding={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}  fullWidth size="small" sx={{height:"20px"}} >
            <TimePicker
             fullWidth size="small"
              // sx={{ width: "100%", color:"black", fontWeight:"500" }}
              label="School Start Time "
              value={form?.startTime ? dayjs(form.startTime) : null}
              onChange={(newValue) => {
                const formattedTime = newValue ? dayjs(newValue).format("HH:mm:ss") : "";
                changeHandler("startTime", formattedTime);
              }}
              renderInput={(params) => <TextField {...params} fullWidth  size="small" sx={{height:"20px"}} />}
              sx={{
                '& .MuiInputLabel-root': {
                  color: 'black',
                  fontWeight: 500,
                },
                width: "100%",
              }}
              InputProps={{
                style: {
                  color: '#111',
                  fontWeight: 500,
                  WebkitTextFillColor: '#111',
                  opacity: 1,
                  background: 'transparent',
                }
              }}
            />
            <TimePicker
              // sx={{ width: "100%" }}
              sx={{
                '& .MuiInputLabel-root': {
                  color: 'black',
                  fontWeight: 500,
                },
                width: "100%",
              }}
              InputProps={{
                style: {
                  color: '#111',
                  fontWeight: 500,
                  WebkitTextFillColor: '#111',
                  opacity: 1,
                  background: 'transparent',
                }
              }}
              label="School End Time "
              value={form?.endTime ? dayjs(form.endTime, "HH:mm:ss") : null}
              onChange={(newValue) => {
                const formattedTime = newValue ? dayjs(newValue).format("HH:mm:ss") : "";
                if (
                  form?.startTime &&
                  formattedTime &&
                  dayjs(form.startTime, "HH:mm:ss").isAfter(dayjs(formattedTime, "HH:mm:ss"))
                ) {
                  setErrors((prev) => ({
                    ...prev,
                    endTime: "End Time must be after Start Time",
                  }));
                } else {
                  setErrors((prev) => ({ ...prev, endTime: undefined }));
                  changeHandler("endTime", formattedTime);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  error={!!errors.endTime}
                  helperText={errors.endTime}
                />
              )}
            />
          </LocalizationProvider>
          <TextField label="Strength"
            value={form?.strength || ""}
            type="text"
            fullWidth size="small"
            onChange={(e) => changeHandler("strength", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              }
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
        </Stack>

        <Stack direction={"row"} spacing={2} padding={2}>

          <TextField label="Pincode" value={form?.pincode || ""} type="text" fullWidth
            required
            error={errors.pincode ? true : false}
             size="small"
            onChange={async (e) => {
              const inputValue = e.target.value;
              const sanitizedValue = inputValue?.replace(/[^0-9]/g, '').slice(0, 6);
              if (sanitizedValue?.length <= 7) {
                if (sanitizedValue?.length === 6) {
                  await fetchPinCode(sanitizedValue);
                }
                changeHandler("pincode", sanitizedValue);
              }
            }}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          <TextField  fullWidth size="small" required label="State" disabled InputLabelProps={{
            shrink: true,
            
          }} value={form?.state} type="text"
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              '& .MuiInputBase-input.Mui-disabled': {
                color: '#111 !important',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }} />
          <TextField required fullWidth size="small" label="District" disabled InputLabelProps={{
            shrink: true,
          }} value={form?.district} type="text" 
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              '& .MuiInputBase-input.Mui-disabled': {
                color: '#111 !important',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }} />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          {/* <TextField required label="District" disabled InputLabelProps={{
            shrink: true,
          }} value={form?.district} type="text" fullWidth
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              '& .MuiInputBase-input.Mui-disabled': {
                color: '#111 !important',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }} /> */}
          <TextField size="small" label="Address 1" value={form?.addressLine1} type="text" fullWidth onChange={(e) => changeHandler("addressLine1", e.target.value)} required error={errors.addressLine1 ? true : false}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          <TextField label="Address 2" value={form?.addressLine2} type="text" fullWidth size="small" onChange={(e) => changeHandler("addressLine2", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          <TextField  label="Landmark" value={form?.landmark} type="text" fullWidth size="small" onChange={(e) => changeHandler("landmark", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
           <FormControl size="small" fullWidth>
                      <InputLabel sx={{ background: 'white', fontSize:"14px", fontWeight:"500", color:"black" }} required error={errors.cluster ? true : false}>Select Area </InputLabel>
                      <Select
                        labelId={`Cluster`}
                        label="Select Area"
                        value={form?.cluster || ""}
                        sx={{fontSize:"14px", fontWeight:"500", color:"black"}}
                        onChange={(e) => changeHandler("cluster", e.target.value)}
                        required error={errors.cluster ? true : false}
                      >
                        {clusters?.map((option, optionIndex) => (
                          <MenuItem key={option.id} value={option.dbId} sx={{fontSize:"14px", fontWeight:"500", color:"black"}}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
        </Stack>
        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="Address Line 2" value={form?.addressLine2} type="text" fullWidth onChange={(e) => changeHandler("addressLine2", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
          <TextField label="Landmark" value={form?.landmark} type="text" fullWidth onChange={(e) => changeHandler("landmark", e.target.value)}
            sx={{
              '& .MuiInputLabel-root': {
                color: 'black',
                fontWeight: 500,
              },
              width: "100%",
            }}
            InputProps={{
              style: {
                color: '#111',
                fontWeight: 500,
                WebkitTextFillColor: '#111',
                opacity: 1,
                background: 'transparent',
              }
            }}
          />
        </Stack> */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginBottom:"10px" }}>
{status ?
  <Button variant="contained" onClick={() => onsubmit(form)} style={{ minWidth: 300 }}>
    Create
  </Button>
:
  <Button variant="contained" onClick={() => onUpdate(form)} style={{ minWidth: 300 }}>
    Update
  </Button>
}

</div>
          </div>
        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="School Affiliation Number/Pan Number"
            value={form?.affiliationPan || ""}
            type="text" fullWidth
            onChange={(e) => changeHandler("affiliationPan", e.target.value)}
            // required error={errors.affiliationPan ? true : false} 
            inputProps={{
              maxLength: 10,
              style: { textTransform: "uppercase" }
            }}
          />
          <TextField label="School Registration Number"
            value={form?.registrationNo || ""}

            type="text"
            fullWidth
            onChange={(e) => changeHandler("registrationNo", e.target.value)}
          />
        </Stack> */}
        {/* <Stack direction={"row"} spacing={2} padding={2}>

          <TextField label="GST No"
            value={form?.gstNo || ""}
            sx={{ width: "100%" }}
            type="text"
            onChange={(e) => changeHandler("gstNo", e.target.value)}
            inputProps={{
              maxLength: 15,
              style: { textTransform: "uppercase" }
            }}
          />
        </Stack> */}
      </div>
    )
  }

  const handleCheckbox = (val) => {

    setChangePassword(val)
    changeHandler("onboardforErp", val)

  }

  // const formatDate = (data) => {
  //   // setDate(data)
  //   const timestamp = new Date(data.$d);

  //   const datePickerResponse = new Date(data.$d);

  //   const year = datePickerResponse.getFullYear();
  //   const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
  //   const day = String(datePickerResponse.getDate()).padStart(2, '0');
  //   const formattedDate = `${year}-${month}-${day}`;
  //   const unixTimestamp = Math.floor(timestamp.getTime() / 1000);
  //   setDate(data)


  //   changeHandler("incorporationDate", unixTimestamp)
  // }


  // const renderContent = (params) => {
  //   return (
  //     <div style={{ maxHeight: "510px", height: "505px", overflowY: "auto" }}>

  //       <Stack direction={"row"} spacing={2} padding={2}>

  //         <TextField label="Pincode" value={form?.pincode || ""} type="text" fullWidth
  //           required
  //           error={errors.pincode ? true : false}
  //           onChange={async (e) => {
  //             const inputValue = e.target.value;
  //             const sanitizedValue = inputValue?.replace(/[^0-9]/g, '').slice(0, 6);
  //             if (sanitizedValue?.length <= 7) {
  //               if (sanitizedValue?.length === 6) {
  //                 await fetchPinCode(sanitizedValue);
  //               }
  //               changeHandler("pincode", sanitizedValue);
  //             }
  //           }}
  //         />
  //         <TextField required label="State" disabled InputLabelProps={{
  //           shrink: true,
  //         }} value={form?.state} type="text" fullWidth />
  //       </Stack>
  //       <Stack direction={"row"} spacing={2} padding={2}>
  //         <TextField required label="District" disabled InputLabelProps={{
  //           shrink: true,
  //         }} value={form?.district} type="text" fullWidth />
  //         <TextField label="Address Line 1" value={form?.addressLine1} type="text" fullWidth onChange={(e) => changeHandler("addressLine1", e.target.value)} required error={errors.addressLine1 ? true : false} />
  //       </Stack>
  //       <Stack direction={"row"} spacing={2} padding={2}>
  //         <TextField label="Address Line 2" value={form?.addressLine2} type="text" fullWidth onChange={(e) => changeHandler("addressLine2", e.target.value)} />
  //         <TextField label="Landmark" value={form?.landmark} type="text" fullWidth onChange={(e) => changeHandler("landmark", e.target.value)} />
  //       </Stack>
  //       {/* <Stack direction={"row"} spacing={2} padding={2}>
  //         <strong>Bank Details</strong>
  //       </Stack> */}
  //       {/* <Stack direction={"row"} spacing={2} padding={2}>
  //         <TextField label="Bank Name" value={form?.bankName || ""} type="text" fullWidth onChange={(e) => changeHandler("bankName", e.target.value)} />
  //         <TextField label="Bank Account Holder name" value={form?.holderName || ""} type="text" fullWidth onChange={(e) => changeHandler("holderName", e.target.value)} />
  //       </Stack> */}
  //       {/* <Stack direction={"row"} spacing={2} padding={2}>
  //         <TextField label="Branch Name" value={form?.branchName || ""} type="text" fullWidth onChange={(e) => changeHandler("branchName", e.target.value)} />

  //         <TextField label="Bank Account Number" value={form?.accountNo || ""} type="text" fullWidth onChange={(e) => changeHandler("accountNo", e.target.value)} />
  //       </Stack> */}

  //       {/* <Stack direction={"row"} spacing={2} padding={2}>
  //         <TextField label="IFSC Code" value={form?.ifsc || ""} type="text" fullWidth onChange={(e) => changeHandler("ifsc", e.target.value)} />
  //       </Stack> */}

  //     </div>
  //   );
  // };

  const detailUpdate = (fieldName, value) => {
    debugger
    setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
  }
  const uploadFile = async (type, val) => {
    const formData = new FormData();
    // Assuming val is a file object passed from input
    const imageFile = val?.file;

    // Append the file to form data
    formData?.append('file', imageFile);
    formData?.append('filename', 'captured_image.jpg');

    try {
      let upload = await window.Platform.database.uploadImageApi(formData);
      if (upload[0]) {
        const { status, message, link } = upload[0];
        if (!status) {
          try {
            const headers = {
              'Content-Type': imageFile.type,
            };
            const response = await axios.put(link.presignedUrl, imageFile, {
              headers: headers,
            });
            if (response?.status === 200) {
              setFileUrl(link?.fileUrl);  // Set the uploaded file URL
              console.log('File uploaded successfully!');
            } else {
              console.error('Upload failed:', response);
            }
          } catch (error) {
            console.error('Upload error:', error);
          }
        } else {
          console.log(message); // Handle message if status is true
        }
        switch (type) {
          case 'cancelCheck':
            changeHandler("chequePic", link?.fileUrl);
            setIsCancelChequeUploaded(true);
            break;
          case 'schoolPhoto':
            changeHandler("schoolPic", link?.fileUrl);
            setIsSchoolPhotoUploaded(true);
            break;
          case 'panCard':
            changeHandler("panPic", link?.fileUrl);
            setIsPanCardUploaded(true);
            break;
          case 'personPhoto':
            changeHandler("contactPersonPic", link?.fileUrl);
            setIsContactPersonUploaded(true);
            break;
        }
      }
    } catch (error) {
      console.error('Error during upload:', error?.message);
    }
  };


  // const renderContent2 = (params) => {
  //   return (
  //     <div style={{ maxHeight: "510px", height: "505px", overflowY: "auto" }}>
  //       <Stack direction={"row"} spacing={2} padding={2}>
  //         <input
  //           type="file"
  //           accept=".pdf, .jpg, .jpeg, .png"
  //           style={{ display: 'none ' }}
  //           id="cancel-check"
  //           onChange={(e) => {
  //             uploadFile('cancelCheck', { file: e.target.files[0], filename: "image" });
  //           }}
  //         />
  //         <label htmlFor="cancel-check" style={{ marginLeft: '0px' }}>
  //           <Button
  //             label="Choose File"
  //             value={form?.chequePic || ''}
  //             fullWidth
  //             variant="outlined"
  //             onClick={() => document.getElementById('cancel-check').click()}
  //           >
  //             Upload Cancel Check
  //           </Button>
  //         </label>

  //         {isCancelChequeUploaded && (
  //           <Box sx={{ display: 'flex', alignItems: 'center', color: 'green' }}>
  //             <CheckCircleIcon sx={{ marginRight: 1 }} />
  //             <span>Cancel Check Uploaded Successfully</span>
  //           </Box>
  //         )}
  //       </Stack>

  //       <Stack direction={"row"} spacing={2} padding={2}>
  //         <input
  //           type="file"
  //           accept=".pdf, .jpg, .jpeg, .png"
  //           style={{ display: 'none ' }}
  //           id="school-photo"
  //           onChange={(e) => {
  //             uploadFile('schoolPhoto', { file: e.target.files[0], filename: "image" });
  //           }}
  //         />
  //         <label htmlFor="school-photo" style={{ marginLeft: '0px' }}>
  //           <Button
  //             label="Choose File"
  //             value={form?.schoolPic || ''}
  //             fullWidth
  //             variant="outlined"
  //             onClick={() => document.getElementById('school-photo').click()}
  //           >
  //             Upload School Photo
  //           </Button>
  //         </label>

  //         {isSchoolPhotoUploaded && (
  //           <Box sx={{ display: 'flex', alignItems: 'center', color: 'green' }}>
  //             <CheckCircleIcon sx={{ marginRight: 1 }} />
  //             <span>School Photo Uploaded Successfully</span>
  //           </Box>
  //         )}
  //       </Stack>

  //       <Stack direction={"row"} spacing={2} padding={2}>
  //         <input
  //           type="file"
  //           accept=".pdf, .jpg, .jpeg, .png"
  //           style={{ display: 'none ' }}
  //           id="pan-card"
  //           onChange={(e) => {
  //             uploadFile('panCard', { file: e.target.files[0], filename: "image" });
  //           }}
  //         />
  //         <label htmlFor="pan-card" style={{ marginLeft: '0px' }}>
  //           <Button
  //             label="Choose File"
  //             value={form?.panPic || ''}
  //             fullWidth
  //             variant="outlined"
  //             onClick={() => document.getElementById('pan-card').click()}
  //           >
  //             Upload PAN Card/ Affiliation Photo
  //           </Button>
  //         </label>

  //         {isPanCardUploaded && (
  //           <Box sx={{ display: 'flex', alignItems: 'center', color: 'green' }}>
  //             <CheckCircleIcon sx={{ marginRight: 1 }} />
  //             <span>PAN Card Uploaded Successfully</span>
  //           </Box>
  //         )}
  //       </Stack>

  //       <Stack direction={"row"} spacing={2} padding={2}>
  //         <input
  //           type="file"
  //           accept=".pdf, .jpg, .jpeg, .png"
  //           style={{ display: 'none ' }}
  //           id="person-photo"
  //           onChange={(e) => {
  //             uploadFile('personPhoto', { file: e.target.files[0], filename: "image" });
  //           }}
  //         />
  //         <label htmlFor="person-photo" style={{ marginLeft: '0px' }}>
  //           <Button
  //             label="Choose File"
  //             value={form?.contactPersonPic || ''}
  //             fullWidth
  //             variant="outlined"
  //             onClick={() => document.getElementById('person-photo').click()}
  //           >
  //             Contact Person Photo
  //           </Button>
  //         </label>

  //         {isContactPersonUploaded && (
  //           <Box sx={{ display: 'flex', alignItems: 'center', color: 'green' }}>
  //             <CheckCircleIcon sx={{ marginRight: 1 }} />
  //             <span>Contact Person Image Uploaded Successfully</span>
  //           </Box>
  //         )}
  //       </Stack>

  //       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: "19px" }}>
  //         {status ?
  //           <Button variant="contained" onClick={() => onsubmit(form)} >
  //             Create
  //           </Button> : <Button variant="contained" onClick={() => onUpdate(form)} >
  //             Update
  //           </Button>}
  //       </div>
  //     </div>
  //   );
  // };

  const getLeadParty = async (data) => {
    try {
      setLoading(true)
      const results = await window.Platform.database.getLeadParty({ ownerId: data });
      setLead(results.data)
      setLoading(false)

    }
    catch (err) {
      console.log(err)
      setLoading(false)

    }
  }

  // const getGrade = async (data) => {
  //   try {
  //     setLoading(true)
  //     const results = await window.Platform.database.getGrade();
  //     setGrade(results.data)
  //     setLoading(false)

  //   }
  //   catch (err) {
  //     console.log(err)
  //     setLoading(false)

  //   }
  // }
  const getGrade = async (data) => {
    try {
      setLoading(true);
      const results = await window.Platform.database.getGrade();
      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
      else {
        setGrade(results.data);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };


  const getContactPersonRole = async (data) => {
    try {
      setLoading(true)
      const results = await window.Platform.database.getContactPersonRole();
      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
      else {
        setContactPersonRole(results.data)
        setLoading(false)
      }


    }
    catch (err) {
      console.log(err)
      setLoading(false)

    }
  }
  const fetchEmployees = async () => {
    try {
      setLoading(true)
      const results = await window.Platform.database.getUsersForWork();
      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
      else {
        setEmployee(results.data)
        setAssignedEmp(null)
      }
      if (!status) {
        if (dataProp && dataProp[0].onboardForErp === 1) {
          setChangePassword(true)
        }
        const filteredEmp = results?.data?.filter((data) => data?.id == dataProp[0]?.ownerId)
        setAssignedEmp(filteredEmp[0])
      }
      setLoading(false)
    }
    catch (err) {
      console.log(err)
    }


  }

  const fetchDistributors = async (data) => {
    try {
      setLoading(true)
      // const results = await window.Platform.database.getDistributor();
      const results = await window.Platform.database.getAllDistri();
      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showWarning(results?.message || "Something Went Wrong");
        return;
      }
      else {
        setDistributor(results?.data)
        setSelectDistributor(null)
      }
      // if (!status) {
      //   const filteredEmp = results?.data?.filter((data) => data?.distributorID === dataProp && dataProp[0]?.distributorID)

      //   setSelectDistributor(filteredEmp[0])

      // }
      if (dataProp && dataProp[0]) {
        const filteredDistributor = results?.data?.find((data) => data?.distributorID === dataProp[0]?.distributorID);
        setSelectDistributor(filteredDistributor);
      }
      setLoading(false)

    } catch (err) {
      setLoading(false)

      console.log(err)
    }

  }
  const getBoard = async (data) => {
    setLoading(true);
    let results = await window.Platform.database.getBoard();
    if (results?.hasError) {
      setLoading(false);
      window.NotificationUtils.showWarning("Something Went Wrong");
    }
    else {
      setBoard(results.data)
      setLoading(false);
    }


  }
  const getPartySource = async () => {
    setLoading(true);
    let results = await window.Platform.database.getInputSourceList();
    if (results?.status) {
      setPartySources(results?.data)
      setLoading(false);
    }
    else {
      setLoading(false);
      window.NotificationUtils.showWarning("Something Went Wrong");
    }
  }
  const getMedium = async (data) => {
    setLoading(true);
    let results = await window.Platform.database.getMedium();
    if (results?.hasError) {
      setLoading(false);
      window.NotificationUtils.showWarning("Something Went Wrong");
    } else {
      setMedium(results.data)
      setLoading(false);
    }
  }

  const validateForm = (data) => {
    const gstRegex = /^[0-9]{2}[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    let panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    const errors = {};

    // if (data.startTime && data.endTime) {
    //   const start = dayjs(data.startTime, "HH:mm:ss");
    //   const end = dayjs(data.endTime, "HH:mm:ss");
    //   if (end.isSameOrBefore(start)) {
    //     errors.endTime = "End Time must be after Start Time";
    //   }
    // }
    // if (data.startTime && data.endTime) {
    //   const start = dayjs(data.startTime, "HH:mm:ss");
    //   const end = dayjs(data.endTime, "HH:mm:ss");

    //   if (dayjs.extend(isSameOrBefore)) {
    //     errors.endTime = "End Time must be after Start Time";
    //   }
    // }

    if (!data.ownerId?.trim()) {
      errors.assignTo = "Assign to is required";
    }
    // if (!data?.inputSource?.trim()) {
    //   errors.inputSource = "Input Source is required";
    // }
    // if (!/\S+@\S+\.\S+/.test(data.email)) {
    //   errors.email = 'Email is invalid';
    // }

    if (!data?.schoolName?.trim()) {
      errors.schoolName = "School name is required";
    }
 if (!data?.routeName?.trim()) {
      errors.routeName = "Route name is required";
    }
    // if (!data?.board?.trim()) {
    //   errors.board = "School board is required";
    // }

    // if (!data?.medium?.trim()) {
    //   errors.medium = "School medium is required";
    // }

    // if (!data.email?.trim()) {
    //   errors.email = "email is required";
    // }

    // if (!data?.makerName?.trim()) {
    //   errors.makerName = "Decision maker name is required";
    // }

    // if (!data?.makerContact?.trim()) {
    //   errors.makerContact = "Decision maker contact number is required";
    // }
    // if (!data?.makerRole?.trim()) {
    //   errors.makerRole = "Decision maker Role is required";
    // }


    if (!data?.pincode?.trim()) {
      errors.pincode = "Pin code is required";
    } else if (data?.pincode.length < 6) {
      errors.pincode = "Pin should be 6 digits long.";
    }

    if (!data?.addressLine1?.trim()) {
      errors.addressLine1 = "AddressLine1 is required";
    }
     if (!data?.cluster) {
      errors.cluster = "Area is required";
    }


    return errors;
  };

const onsubmit = async (data) => {
  // console.log("Submitted data:", data, "Form state:", form);

  try {
    const errors = validateForm(form);
    setErrors(errors);

    form.grade = selectedGrade;

    if (Object.keys(errors).length === 0) {
      setLoading(true);

      let finalData = {
        ...form,
        onboardforErp: changePassword,
        grade: selectedGrade
      };
      
      const result = await window.Platform.database.addSchool(finalData);

      if (!result?.status) {
        window.NotificationUtils.showSuccess("School added successfully.");
        fetchData?.();               // Optional if provided
        onClose1?.(finalData); 
              // Close the modal with final data
      } else {  
        window.NotificationUtils.showWarning(result?.message || "Failed to add school.");
      }

      setLoading(false);
    } else {
      setLoading(false);
      window.NotificationUtils.showWarning("Please fill all required fields to proceed");
    }
  } catch (error) {
    setLoading(false);
    console.error("Add school error:", error);
    window.NotificationUtils.showWarning("Something went wrong during submission.");
  }
};



  const onUpdate = async (data) => {
    try {
      const errors = validateForm(form);
      setErrors(errors);

      if (Object.keys(errors).length === 0) {
        setLoading(true);
        const obj = { ...data, id: dataProp && dataProp[0].schoolId, onboardforErp: changePassword, grade: selectedGrade };
        // delete obj["startTime"];
        // delete obj["endTime"];
        const results = await window.Platform.database.editPartySchool(obj);
        window.NotificationUtils.showSuccess("Party updated succesfully.");
        onClose();
        fetchData();
        setLoading(false);
      } else {
        setLoading(false);
        window.NotificationUtils.showWarning("Please fill all required fields to proceed");
      }
    }
    catch (err) {
      setLoading(false);
      console.log(err)
    }
  }

  const fetchPinCode = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.fetchPinCode(details);
      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
      else {
        setForm({ ...form, state: results?.data[0]?.StateName, district: results?.data[0]?.District });
        setLoading(false)
      }
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }
  // const isAddressDetailShow = !form?.ownerId || !form?.schoolName || !form?.makerRole || !form?.makerContact || !form?.makerName || !form?.schoolCategory || !form?.email || !form?.board || !form?.medium || !form?.startTime || !form?.endTime;
  // const isAddressDetailShow = !form?.ownerId || !form?.schoolName || !form?.routeName;
  // const isUploadImageShow = !form?.pincode || !form?.addressLine1;
  return (
  
  <>
  
      {loading && <OpaqueLoading />}

      <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
        <Typography
          variant={isMobile ? "h6" : "h5"}
          sx={{ color: "black", fontSize: "18px", fontWeight: "500" }}
        >
       {status ? "Add School" : "Edit School "}

          {/* 
          <Tooltip title="Order Id">
            {id}
          </Tooltip> 
          */}
        </Typography>

      <Button
  variant="text"
  startIcon={<ArrowBackIos />}
  onClick={onClose}
  sx={{ marginBottom: 2 }}
>
  Back
</Button>

      </ModalHeaderContainer>

      <TableContainer>
        <TabsContainer>
          {/*
          <StyledTabs
            variant="fullWidth"
            value={tabValue}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="School Details" />
            <Tab label="Address/Bank Details" disabled={isAddressDetailShow} />
            <Tab label="Upload Images" disabled={isUploadImageShow} />
          </StyledTabs>
          */}

          {tabValue === 0 && renderContent1()}
          {/* {tabValue === 1 && renderContent()} */}
          {/* {tabValue === 2 && renderContent2()} */}
        </TabsContainer>
      </TableContainer>
    
  </>

  );
};

export default SchoolModal;